// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"534":"Expired","601":"new-features","810":"NotFound"}[chunkId] || chunkId) + "-legacy." + {"215":"e605c219","534":"11ccc398","601":"11ca795c","810":"bb2a62dd","926":"e4c6f29b"}[chunkId] + ".js";
};